<template>
    <div>
        <b-modal id="PasswordModal" size="md" :visible="true" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" centered :title="$t('insuranceSetup.Password')" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')">
        <div v-if="errorMessage" class="pt-3">
            <div id="alert" class="alert alert-fill-danger" role="alert">
              <i class="mdi mdi-alert-circle"></i>
              {{ errorMessage }}
            </div>
        </div>      
        <b-row>
           <b-col lg="12" md="12" sm="12">
            <MdSelect
                v-bind:Label="$t('MdNote.Cosignedby')"
                data-field="cotherapistcode"
                v-bind:Options="CoTherapistsList"
                v-bind:FieldDescription="'fullName'"
                v-bind:FieldCode="'code'"
                v-bind:IsDisabled="NoteIsReadOnly || IsGroupNote && IsCommonPart === false"
                v-bind:ModelArray="CoTherapistModal"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownCoTherapistSignandSave"
                v-bind:Tag="Id"
          />
           </b-col>
        </b-row>
        <b-row>
           <b-col lg="12" md="12" sm="12">
              <MdPassword 
                 v-bind:Label="$t('MdPasswordDlg.EnterPassword')"
                 v-bind:TypeProp="'password'" 
                 v-bind:Name="'password'"
                 v-bind:Autocomplete="true"
                 v-bind:NoValidateChanges="NoValidateChanges"
                 v-bind:MaxLengthProp="45"
                 v-model="password"
                 ref="inputPassword"
                 v-bind:Id="'inputPassword'"
                 v-bind:isEndControl="true"
                 v-bind:EndControlFunction="checkPassword"
                 >                                     
              </MdPassword>
           </b-col>
        </b-row>
      </b-modal>
    </div>
</template>
  
  <script>
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import UserService from '@/services/user.service'
  import StorageService from '@/services/storage.service'
    export default {
    props: {
      Operation:String,
      Type: String,
      VerificationType:String,
      ShowPopup: Boolean,
      NoValidateChanges: Boolean, 
      CoTherapistsList:Array,
      NoteIsReadOnly:Boolean,
      IsGroupNote:Boolean,
      IsCommonPart:Boolean,
      Id:String,
      EmployeeCode:String,
      CoTherapists:[Object,String] 
    },
    
      mixins: [ShowMessage],
      data() {
        return { 
          password: '',
          errorMessage: null,
          CoTherapistModal:this.CoTherapists
        }
      },
      
      methods:{
        emitEventOK(){
          this.checkPassword()
        },

        SetTherapists(){ 
            if(this.CoTherapists !== undefined && this.CoTherapists.code === ""){ 
                var l = this.CoTherapistsList.length;
                for(var i = 0; i < l; i++){
                    if(this.CoTherapistsList[i].code.toLowerCase() == this.EmployeeCode.toLowerCase()){
                    this.CoTherapistModal = this.CoTherapistsList[i];
                    }
                }
            }             
        },

        ChangeDropDownCoTherapistSignandSave(value){
            this.CoTherapistModal = value;
        },
  
        emitEventCancel(){
          this.$emit('getModalPasswordCoSignandSave', {"status":false,"type":this.Type,"Event":"Cancel"});
        }, 
  
        checkPassword() {
          const password = this.password;
          if(this.VerificationType === 'SupervisorPassword'){
            if(password !== ''){
              var data = {
                SupervisorPassword : password
              };
              UserService.verifySupervisorPassword(data)
                 .then((response) => {
                   if(response.status == '200'){   
                    this.$emit('getModalPasswordCoSignandSave', {"status":response.data,"type":this.Type,"Event":"Ok","Operation":this.Operation});             
                    /*if(response.data === true){
                      this.$emit('getModalPassword', {"status":true});
                    }else{
                      this.$emit('getModalPassword', {"status":false});
                    }*/              
                     
                   }
                 })
                  .catch((error) => {
                     if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('MdPasswordDlg.NoAblePasswordMsg'),"error");
                    } else {
                        this.$emit('getModalPasswordCoSignandSave',{"status":false,"type":this.Type,"Event":"Ok","Operation":this.Operation,"message":error.response.data.message});
                    }
                  });
            }else{             
              this.$emit('getModalPasswordCoSignandSave',{"status":false,"type":this.Type,"Event":"Ok","Operation":this.Operation});        
            }
          }else{
            const clientId = StorageService.getClientId();         
          if( clientId !== '' && this.CoTherapistModal.code !== '' && password !== '' ){
           UserService.verifyPassword(clientId, null, this.CoTherapistModal.code, password)
                 .then((response) => {
                   if(response.status == '200'){
                     this.$emit('getModalPasswordCoSignandSave', {"status":true,"type":this.Type,"Event":"Ok","Operation":this.Operation,CoTherapist:this.CoTherapistModal.code});
                   }
                 })
                  .catch((error) => {
                     if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('MdPasswordDlg.NoAblePasswordMsg'),"error");
                    } else {
                        this.$emit('getModalPasswordCoSignandSave',{"status":false,"type":this.Type,"Event":"Ok","Operation":this.Operation,"message":error.response.data.message});
                    }
                  });
          } else {
            this.$emit('getModalPasswordCoSignandSave',{"status":false,"type":this.Type,"Event":"Ok","Operation":this.Operation});
          }
          }
  
         
  
  
        }
  
  
  
      },
  
      mounted(){
        this.SetTherapists();
        this.$nextTick(() => {
          setTimeout(() =>  this.$refs.inputPassword.setFocus(), 500);
        });
  
        /*window.addEventListener('keyup', event => {
          if (event.keyCode === 13) { 
            this.emitEventOK()
          }
        })*/
      }
    }
  
  </script>